@if (show) {
  <div
    [@fadeInOut]>
    <div #ref class="navigation-indicator-container"><ng-content></ng-content></div>
    <!-- If no content is provided, use the below progress bar -->
    @if (!ref.innerHTML.trim()) {
      <div class="navigation-indicator-progress">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="100" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>
    }
  </div>
}
